import { render, staticRenderFns } from "./SendViaEmailModal.vue?vue&type=template&id=07666d3f&scoped=true&"
import script from "./SendViaEmailModal.vue?vue&type=script&lang=js&"
export * from "./SendViaEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./SendViaEmailModal.vue?vue&type=style&index=0&id=07666d3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07666d3f",
  null
  
)

export default component.exports